import BaseTheme from './base';
export const ChildbaseTheme = {
    ...BaseTheme,
    title: 'Childbase',
    chromeColor: '#B20E10',
};
